import LegalPageTemplate from "@/components/LegalPageTemplate";
import LegalDocument from "@/components/LegalDocument";
import { useLocale } from "@/lib/locale";

export default function BiometricConsentPage() {
    const { t } = useLocale();
    return (
        <LegalPageTemplate
            docType="biometric"
            title={t("legal.biometric_title")}
            eyebrow={t("legal.biometric_eyebrow")}
            version="2026-02-v1"
        >
            <LegalDocument docKey="biometric" />
        </LegalPageTemplate>
    );
}
